(function () {

    var DEBUG = false;

    function log() {
        if (DEBUG) console.log.apply(console, arguments);
    }

    var FLUSH_INTERVAL = 10000; // 10 seconds
    var CONTAINER_SELECTOR = '[data-track-impressions]';
    var ITEM_SELECTOR = '[data-stat-id][data-stat-model]:not([data-stat-event]), [data-stat-id][data-stat-model][data-stat-track-impression]';
    var DEFAULT_MODEL = 'ad';

    var buffers = {}; // keyed by model: { pending: Array, sent: Set }
    var flushTimerStarted = false;

    // Models where the same ID can appear multiple times per page (e.g. same partner on many ads)
    var COUNTABLE_MODELS = ['financing_partner'];

    // Models that support a `data-promotion` suffix on the impression key (e.g. id:daily_offer)
    var PROMOTABLE_MODELS = ['ad', 'dealer'];

    /**
     * Get or create a buffer for a given model
     */
    function getBuffer(model) {
        if (!buffers[model]) {
            buffers[model] = { pending: [], sent: new Set() };
        }
        return buffers[model];
    }

    /**
     * Read the impression ID from an element
     */
    function getItemId(el) {
        if (!el) return null;
        return el.dataset.statId || null;
    }

    /**
     * Read per-item model override (returns null if not set)
     */
    function getItemModel(el) {
        if (!el) return null;
        // Unified stat-model attribute (most explicit)
        if (el.dataset.statModel) return el.dataset.statModel;
        return null;
    }

    /**
     * Collect a single item into the correct model buffer
     */
    function collectItem(containerModel, el, source) {
        var id = getItemId(el);
        if (!id) return;
        var model = getItemModel(el) || containerModel;
        var promotion = PROMOTABLE_MODELS.indexOf(model) !== -1 ? el.dataset.promotion : null;
        var key = promotion ? id + ':' + promotion : id;
        collectIds(model, [key], source);
    }

    /**
     * Extract items from currently visible slides of a swiper instance
     */
    function collectVisibleSlides(swiper, containerModel, source) {
        if (!swiper || !swiper.slides || !swiper.params) return;

        var start = swiper.activeIndex;
        var count = Math.ceil(swiper.params.slidesPerView);

        for (var i = start; i < start + count && i < swiper.slides.length; i++) {
            var els = swiper.slides[i].querySelectorAll(ITEM_SELECTOR);
            for (var e = 0; e < els.length; e++) {
                collectItem(containerModel, els[e], source);
            }
        }
    }

    /**
     * Collect new IDs (not already sent or pending) for a given model
     */
    function collectIds(model, ids, source) {
        var buf = getBuffer(model);
        var countable = COUNTABLE_MODELS.indexOf(model) !== -1;
        var newIds = [];

        for (var i = 0; i < ids.length; i++) {
            var id = ids[i];
            if (countable || (!buf.sent.has(id) && buf.pending.indexOf(id) === -1)) {
                buf.pending.push(id);
                newIds.push(id);
            }
        }

        if (newIds.length > 0) {
            log('[ImpressionTracker] ' + source + ' [' + model + '] — new IDs:', newIds);
        }
    }

    /**
     * Flush pending IDs via batch beacon (all models)
     */
    function flush() {
        var models = Object.keys(buffers);
        var flushed = false;

        for (var m = 0; m < models.length; m++) {
            var model = models[m];
            var buf = buffers[model];

            if (buf.pending.length === 0) continue;

            var ids = buf.pending.slice();
            log('[ImpressionTracker] Flush [' + model + '] — sending ' + ids.length + ' IDs:', ids);

            // For unique-ID models, track sent IDs to prevent re-sending
            if (COUNTABLE_MODELS.indexOf(model) === -1) {
                for (var i = 0; i < ids.length; i++) {
                    buf.sent.add(ids[i]);
                }
            }
            buf.pending = [];

            if (typeof window.trackBatchImpressions === 'function') {
                window.trackBatchImpressions(model, ids);
            }

            flushed = true;
        }

        if (!flushed) {
            log('[ImpressionTracker] Flush skipped — no pending IDs');
        }
    }

    /**
     * Get swiper instance from a container element
     */
    function getSwiperFromElement(el) {
        if (!el) return null;
        var swiperEl = el.querySelector('.swiper');
        return swiperEl ? swiperEl.swiper : null;
    }

    /**
     * Attach slide change listener to a swiper instance
     */
    function attachSwiperListener(swiper, model) {
        if (!swiper || swiper._impressionTrackerAttached) return;

        swiper.on('slideChangeTransitionEnd', function () {
            collectVisibleSlides(swiper, model, 'Swiper slide change');
        });

        swiper._impressionTrackerAttached = true;
    }

    /**
     * Start global flush timers (once, shared across all containers)
     */
    function startFlushTimers() {
        if (flushTimerStarted) return;
        flushTimerStarted = true;

        setInterval(flush, FLUSH_INTERVAL);

        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'hidden') {
                log('[ImpressionTracker] Page hidden — flushing');
                flush();
            }
        });

        window.addEventListener('beforeunload', function () {
            log('[ImpressionTracker] Page unload — flushing');
            flush();
        });
    }

    /**
     * Initialize SWIPER MODE — for containers with carousels/sliders
     */
    function initSwiperMode(container, swiperElements, model) {
        // Attach slide change listeners to all swipers
        for (var i = 0; i < swiperElements.length; i++) {
            var swiper = swiperElements[i].swiper;
            if (swiper) {
                attachSwiperListener(swiper, model);
            }
        }

        // Capture initial visible slides
        var activePane = container.querySelector('.tab-pane.active');

        if (activePane) {
            // Tabbed layout — capture from active tab only
            var activeSwiper = getSwiperFromElement(activePane);
            if (activeSwiper) {
                collectVisibleSlides(activeSwiper, model, 'Initial visible slides');
            }
        } else {
            // No tabs — capture from all swipers in container
            for (var j = 0; j < swiperElements.length; j++) {
                var swiper = swiperElements[j].swiper;
                if (swiper) {
                    collectVisibleSlides(swiper, model, 'Initial visible slides');
                }
            }
        }

        // Listen for tab switches (if tabs exist within this container)
        var tabs = container.querySelectorAll('[data-bs-toggle="tab"]');

        for (var t = 0; t < tabs.length; t++) {
            tabs[t].addEventListener('shown.bs.tab', function (e) {
                var targetSelector = e.target.dataset.bsTarget || e.target.getAttribute('data-bs-target');
                var targetPane = document.querySelector(targetSelector);
                var swiper = getSwiperFromElement(targetPane);

                if (swiper) {
                    swiper.update();
                    attachSwiperListener(swiper, model);
                    collectVisibleSlides(swiper, model, 'Tab switch');
                }
            });
        }
    }

    /**
     * Initialize LIST MODE — for containers with items in a scrollable list
     */
    function initListMode(container, model) {
        var impElements = container.querySelectorAll(ITEM_SELECTOR);
        if (!impElements.length) return;

        log('[ImpressionTracker] List mode [' + model + '] — observing ' + impElements.length + ' items');

        var observer = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
                if (entries[i].isIntersecting) {
                    collectItem(model, entries[i].target, 'Item visible in list');
                    observer.unobserve(entries[i].target);
                }
            }
        }, { threshold: 0 }); // any pixel in viewport = impression (viewport/height independent)

        for (var i = 0; i < impElements.length; i++) {
            observer.observe(impElements[i]);
        }
    }

    /**
     * Flush pending IDs and clear sent history (new search context via AJAX)
     */
    function resetForNewContext() {
        flush();
        var models = Object.keys(buffers);
        for (var m = 0; m < models.length; m++) {
            buffers[models[m]].sent.clear();
        }
        log('[ImpressionTracker] New search context — flushed and reset');
    }

    /**
     * Initialize tracking for a single container — auto-detects swiper vs list mode
     */
    function initContainer(container) {
        var model = container.getAttribute('data-track-impressions') || DEFAULT_MODEL;
        log('[ImpressionTracker] Section visible — initializing [' + model + ']');

        // Skip swipers that belong to a nested [data-track-impressions] container — that container
        // manages its own tracking (e.g. promo-dealer-banner injected into the ad listing).
        // Also skip swipers without a live instance (e.g. responsive sliders destroyed above a breakpoint).
        var swiperElements = container.querySelectorAll('.swiper');
        var activeSwipers = [];
        for (var i = 0; i < swiperElements.length; i++) {
            if (swiperElements[i].closest(CONTAINER_SELECTOR) !== container) continue;
            if (swiperElements[i].swiper) activeSwipers.push(swiperElements[i]);
        }

        if (activeSwipers.length) {
            initSwiperMode(container, activeSwipers, model);
        } else {
            initListMode(container, model);
        }

        startFlushTimers();
    }

    /**
     * Entry point — observe all [data-track-impressions] containers
     */
    window.addEventListener('load', function () {
        var containers = document.querySelectorAll(CONTAINER_SELECTOR);

        if (!containers.length) {
            log('[ImpressionTracker] No trackable sections found');
        } else {
            log('[ImpressionTracker] Observing ' + containers.length + ' section(s)');

            var observer = new IntersectionObserver(function (entries) {
                for (var i = 0; i < entries.length; i++) {
                    if (entries[i].isIntersecting) {
                        observer.unobserve(entries[i].target);
                        initContainer(entries[i].target);
                    }
                }
            }, { threshold: 0 }); // section touched viewport at all — works on any device

            for (var i = 0; i < containers.length; i++) {
                observer.observe(containers[i]);
            }
        }

        // MutationObserver — detect new [data-track-impressions] containers added via AJAX
        var mutationObserver = new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
                var addedNodes = mutations[i].addedNodes;
                for (var j = 0; j < addedNodes.length; j++) {
                    var node = addedNodes[j];
                    if (node.nodeType !== 1) continue;

                    // Check if the added node itself is a tracked container
                    if (node.matches && node.matches(CONTAINER_SELECTOR)) {
                        resetForNewContext();
                        log('[ImpressionTracker] New container detected (AJAX) — initializing');
                        initContainer(node);
                    }

                    // Check children of added node for tracked containers
                    if (node.querySelectorAll) {
                        var newContainers = node.querySelectorAll(CONTAINER_SELECTOR);
                        if (newContainers.length) {
                            resetForNewContext();
                        }
                        for (var k = 0; k < newContainers.length; k++) {
                            log('[ImpressionTracker] New container detected (AJAX) — initializing');
                            initContainer(newContainers[k]);
                        }
                    }
                }
            }
        });

        mutationObserver.observe(document.body, { childList: true, subtree: true });
    });

})();
